import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPlayerDotMeComponent } from './simple-icons-player-dot-me.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPlayerDotMeComponent ],
    exports:      [ SimpleIconsPlayerDotMeComponent ],
    bootstrap:    []
})
export class SimpleIconsPlayerDotMeModule {}
